import { BooleanInput } from './BooleanInput';
import type { Props as BooleanInputProps } from './BooleanInput';

type Props = Omit<BooleanInputProps, 'type'>;

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is on its way out in favor of [Checkbox β](../?path=/docs/beta-checkbox--docs).</span>
 *
 * The `Checkbox` component is exposed for convenience and prefills the `type` prop to `checkbox`.
 *
 * `LabeledCheckbox` (and `LabeledBooleanInput)` wrap a `BooleanInput` with a `FormLabel` to render a full input and label combination. These components should be leveraged for most simple `BooleanInput` use cases where text renders beside the input since they define a focus state.
 *
 * @deprecated: Use beta `Checkbox` instead.
 */
export const Checkbox = ({ tabIndex = 0, ...otherProps }: Props) => (
  <BooleanInput type="checkbox" tabIndex={tabIndex} {...otherProps} />
);
